/**
 * update-styles command — replace admin-globals.css with the latest version
 */

import fs from 'node:fs'
import path from 'node:path'
import * as clack from '@clack/prompts'
import type { UpdateStylesCommandOptions } from '@core-engine/commands/runtime.js'
import {
  applyAdminNamespaceToContent,
  resolveAdminNamespace
} from '@next-adapter/config/namespace.js'
import { resolveConfig } from '@next-adapter/config.js'
import { readTemplate } from '@next-adapter/template-reader.js'

export async function runUpdateStylesCommand(options: UpdateStylesCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()

  clack.intro('BetterStart Update Styles')

  const config = await resolveConfig(cwd)
  const adminDir = config.paths.admin
  const namespace = resolveAdminNamespace(config.frameworkConfig.next.namespace)
  const targetPath = path.join(cwd, adminDir, namespace.globalsFile)

  if (!fs.existsSync(targetPath)) {
    clack.cancel(`${namespace.globalsFile} not found at ${path.relative(cwd, targetPath)}`)
    process.exit(1)
  }

  fs.writeFileSync(
    targetPath,
    applyAdminNamespaceToContent(readTemplate('admin-globals.css'), namespace.segment),
    'utf-8'
  )

  clack.log.success(`Updated ${path.relative(cwd, targetPath)}`)
  clack.outro('Styles updated')
}
